// Every string a resident reads, in English and Hindi side by side.
// Hindi is first-draft by the designer and FLAGGED FOR NATIVE REVIEW before any release.
// Grammar notes: `[m|f]` picks the verb form by the gender of the person the sentence is about
// (vars.g). Past-tense "ने" constructions are used where possible because they do not inflect for the speaker.

export type Lang = 'en' | 'hi';
type Entry = { en: string; hi: string };

const S = {
  // Shell
  'app.name': { en: 'Gulmohar Colony market', hi: 'गुलमोहर कॉलोनी बाज़ार' },
  'tab.nearby': { en: 'Nearby', hi: 'आस-पास' },
  'tab.sell': { en: 'Sell', hi: 'बेचें' },
  'tab.chats': { en: 'Chats', hi: 'बातचीत' },
  'tab.me': { en: 'Me', hi: 'मैं' },
  'tab.cases': { en: 'Cases', hi: 'मामले' },
  'tab.rules': { en: 'Rules', hi: 'नियम' },
  'tab.triage': { en: 'Reports', hi: 'शिकायतें' },
  'common.back': { en: 'Back', hi: 'वापस' },
  'common.notNow': { en: 'Not now', hi: 'अभी नहीं' },
  'common.listen': { en: 'Listen', hi: 'सुनें' },
  'common.free': { en: 'Free', hi: 'मुफ़्त' },
  'common.you': { en: 'You', hi: 'आप' },
  'common.optional': { en: 'optional', hi: 'ज़रूरी नहीं' },

  // J1 Join
  'join.title': { en: 'Buy and sell with people who live near you', hi: 'अपने आस-पास रहने वालों से ख़रीदें और बेचें' },
  'join.body': {
    en: 'Neighbours look after the rules here. To join, check your phone number, or join on the word of a neighbour who knows you.',
    hi: 'यहाँ नियमों की देखरेख पड़ोसी ही करते हैं। जुड़ने के लिए अपना फ़ोन नंबर जाँचें, या किसी जान-पहचान वाले पड़ोसी के भरोसे से जुड़ें।',
  },
  'join.withPhone': { en: 'Join with my phone number', hi: 'फ़ोन नंबर से जुड़ें' },
  'join.withVouch': { en: 'A neighbour knows me', hi: 'किसी पड़ोसी के भरोसे से जुड़ें' },
  'join.name': { en: 'What should neighbours call you?', hi: 'पड़ोसी आपको किस नाम से जानें?' },
  'phone.title': { en: 'Your mobile number', hi: 'आपका मोबाइल नंबर' },
  'phone.help': {
    en: 'We send a code to check it. Then the number is forgotten. Neighbours never see it.',
    hi: 'जाँच के लिए हम एक कोड भेजेंगे। उसके बाद नंबर भुला दिया जाता है। पड़ोसी इसे कभी नहीं देखते।',
  },
  'phone.send': { en: 'Send code', hi: 'कोड भेजें' },
  'phone.taken': {
    en: 'This number is already used by a member here. If you changed phones, ask a steward for help.',
    hi: 'यह नंबर यहाँ पहले से किसी सदस्य के पास है। अगर आपने फ़ोन बदला है, तो किसी संचालक से मदद लें।',
  },
  'code.title': { en: 'Enter the 6-digit code', hi: '6 अंकों का कोड डालें' },
  'code.sent': { en: 'Sent by SMS to the number ending {last}.', hi: '{last} पर ख़त्म होने वाले नंबर पर SMS भेजा गया।' },
  'code.demo': { en: 'Prototype: the code is {code}.', hi: 'प्रोटोटाइप: कोड {code} है।' },
  'code.check': { en: 'Check code', hi: 'कोड जाँचें' },
  'code.wrong': { en: "That code doesn't match. Check the SMS and try again.", hi: 'यह कोड मेल नहीं खाता। SMS देखकर फिर से डालें।' },
  'verified.title': { en: 'Your number is checked, and forgotten', hi: 'आपका नंबर जाँच लिया गया, और भुला दिया गया' },
  'verified.body': {
    en: 'Only the fact that it was checked is kept. Now join the colony.',
    hi: 'सिर्फ़ यह बात रखी गई है कि नंबर जाँचा गया था। अब कॉलोनी से जुड़ें।',
  },
  'join.go': { en: 'Join Gulmohar Colony', hi: 'गुलमोहर कॉलोनी से जुड़ें' },
  'joined.title': { en: 'You are now a member', hi: 'अब आप सदस्य हैं' },
  'joined.body': {
    en: 'While you are new, you can keep {items} up for sale at a time. After a trade, {limit}: as soon as the other person says how it went, or {days} days after you both confirm.',
    hi: 'नए सदस्य एक समय में {items} बिक्री पर रख सकते हैं। सौदे के बाद {limit}: जैसे ही सामने वाला बताए कि सौदा कैसा रहा, या दोनों की पुष्टि के {days} दिन बाद।',
  },
  'joined.cta': { en: "See what's for sale nearby", hi: 'आस-पास क्या बिक रहा है, देखें' },
  'vouchAsk.title': { en: 'Ask a neighbour who knows you', hi: 'किसी जान-पहचान वाले पड़ोसी से कहें' },
  'vouchAsk.body': {
    en: 'They must already be a member. Show them this code. They enter it under Me, then Vouch for someone.',
    hi: 'वे पहले से सदस्य होने चाहिए। उन्हें यह कोड दिखाएँ। वे “मैं” में “किसी की पुष्टि करें” पर जाकर इसे डालेंगे।',
  },
  'vouchAsk.waiting': { en: 'Waiting for a neighbour to vouch for you.', hi: 'किसी पड़ोसी की पुष्टि का इंतज़ार है।' },
  'vouchAsk.done': { en: '{name} vouched for you.', hi: '{name} ने आपकी पुष्टि की।' },
  'vouch.title': { en: 'Vouch for someone', hi: 'किसी की पुष्टि करें' },
  'vouch.code': { en: 'Their code', hi: 'उनका कोड' },
  'vouch.find': { en: 'Find', hi: 'ढूँढें' },
  'vouch.found': { en: 'This code belongs to {name}, who is not a member yet.', hi: 'यह कोड {name} का है, जो अभी सदस्य नहीं [है|हैं]।' },
  'vouch.warn': {
    en: 'Only vouch for someone you know in person. Stewards can see who vouched for whom.',
    hi: 'सिर्फ़ उन्हीं की पुष्टि करें जिन्हें आप ख़ुद जानते हैं। संचालक देख सकते हैं कि किसने किसकी पुष्टि की।',
  },
  'vouch.cta': { en: 'Vouch for {name}', hi: '{name} की पुष्टि करें' },
  'vouch.notFound': { en: 'No one is waiting with that code. Check it with them.', hi: 'इस कोड से कोई इंतज़ार नहीं कर रहा। उनसे कोड दोबारा देख लें।' },
  'vouch.done': { en: 'Done. {name} can join now.', hi: 'हो गया। अब {name} जुड़ [सकते|सकती] हैं।' },

  // Feed and item
  'feed.title': { en: 'For sale in Gulmohar Colony', hi: 'गुलमोहर कॉलोनी में बिक्री पर' },
  'feed.empty': { en: 'Nothing for sale right now.', hi: 'अभी कुछ बिक्री पर नहीं है।' },
  'trades.zero': { en: 'No trades here yet', hi: 'यहाँ अभी कोई सौदा नहीं' },
  'trades.one': { en: '1 trade done here', hi: 'यहाँ 1 सौदा पूरा' },
  'trades.other': { en: '{n} trades done here', hi: 'यहाँ {n} सौदे पूरे' },
  'item.ask': { en: 'Ask {name} about this', hi: '{name} से इसके बारे में पूछें' },
  'item.openChat': { en: 'Open your chat with {name}', hi: '{name} से अपनी बातचीत खोलें' },
  'item.yours': { en: 'This is your item. Neighbours can see it.', hi: 'यह आपकी चीज़ है। पड़ोसी इसे देख सकते हैं।' },
  'item.takeDown': { en: 'Take it down', hi: 'बिक्री से हटाएँ' },
  'item.agreed': { en: 'Someone has agreed to buy this.', hi: 'इसे ख़रीदने की बात किसी से पक्की हो चुकी है।' },
  'item.down': { en: 'The seller took this down.', hi: 'बेचने वाले ने इसे हटा दिया है।' },
  'item.pay': { en: 'Pay only when the item is in your hands.', hi: 'पैसे तभी दें जब चीज़ आपके हाथ में हो।' },
  'item.openTrade': { en: 'See the trade', hi: 'सौदा देखें' },
  'item.seller': { en: 'Sold by', hi: 'बेचने वाले' },

  // J3 Ask
  'chat.private': {
    en: 'Only you and {name} can read this chat. It does not go on the colony record.',
    hi: 'यह बातचीत सिर्फ़ आप और {name} पढ़ सकते हैं। यह कॉलोनी के रिकॉर्ड में नहीं जाती।',
  },
  'chat.write': { en: 'Write a message', hi: 'संदेश लिखें' },
  'chat.send': { en: 'Send', hi: 'भेजें' },
  'chat.suggest': { en: 'Is it still available?', hi: 'क्या यह अभी भी मिल सकता है?' },
  'chat.agree': { en: 'Agree to buy for {price}', hi: '{price} में ख़रीदना तय करें' },
  'chat.about': { en: 'About {title}', hi: '{title} के बारे में' },
  'chat.notYours': {
    en: 'This chat belongs to two other people. Only they can read it.',
    hi: 'यह बातचीत दो दूसरे लोगों की है। इसे सिर्फ़ वही पढ़ सकते हैं।',
  },
  'chats.title': { en: 'Chats', hi: 'बातचीत' },
  'chats.empty': { en: 'No chats yet. Ask about an item to start one.', hi: 'अभी कोई बातचीत नहीं। किसी चीज़ के बारे में पूछकर शुरू करें।' },

  // J4 Agree and confirm
  'agree.title': { en: 'Agree to buy {title} for {price}?', hi: '{title} {price} में ख़रीदना तय करें?' },
  'agree.body': {
    en: '{name} will keep it for you. Meet, check it, then pay in person. No payments happen in this app.',
    hi: '{name} इसे आपके लिए [रखेंगे|रखेंगी]। मिलें, चीज़ जाँचें, फिर हाथों-हाथ पैसे दें। इस ऐप में कोई भुगतान नहीं होता।',
  },
  'agree.yes': { en: 'Yes, agree', hi: 'हाँ, तय है' },
  'trade.buyer': { en: 'You agreed to buy this from {name} for {price}.', hi: 'आपने यह {name} से {price} में ख़रीदना तय किया।' },
  'trade.seller': { en: '{name} agreed to buy this for {price}.', hi: '{name} ने इसे {price} में ख़रीदना तय किया।' },
  'trade.next': {
    en: 'Meet, check the item, and pay in person. After the handover, both of you confirm here.',
    hi: 'मिलें, चीज़ जाँचें, और हाथों-हाथ पैसे दें। सौंपने के बाद दोनों यहाँ पुष्टि करें।',
  },
  'trade.received': { en: 'I received it', hi: 'मुझे मिल गया' },
  'trade.handed': { en: 'I handed it over', hi: 'मैंने सौंप दिया' },
  'trade.waiting': { en: 'You confirmed. Waiting for {name} to confirm.', hi: 'आपने पुष्टि कर दी। {name} की पुष्टि का इंतज़ार है।' },
  'trade.theyConfirmed': { en: '{name} has confirmed. Your turn.', hi: '{name} ने पुष्टि कर दी है। अब आपकी बारी।' },
  'trade.done': { en: 'Done. You both confirmed on {date}.', hi: 'सौदा पूरा। आप दोनों ने {date} को पुष्टि की।' },
  'trade.fallthrough': { en: "If it doesn't happen, tell {name} in the chat.", hi: 'अगर सौदा न हो पाए, तो {name} को बातचीत में बता दें।' },
  'trade.rate': { en: 'Say how it went', hi: 'बताएँ कैसा रहा' },
  'trade.rated': { en: 'You said: {word}', hi: 'आपने कहा: {word}' },
  'trade.limitUp': {
    en: '{name} said how it went. You can now keep up to {limit} items up for sale.',
    hi: '{name} ने बताया कि सौदा कैसा रहा। अब आप {limit} चीज़ें तक बिक्री पर रख सकते हैं।',
  },
  'trade.limitWhen': {
    en: 'When {name} says how it went, or on {date} at the latest, you can keep up to {limit} items up for sale.',
    hi: 'जब {name} [बताएँगे|बताएँगी] कि सौदा कैसा रहा, या ज़्यादा से ज़्यादा {date} से, आप {limit} चीज़ें तक बिक्री पर रख सकेंगे।',
  },
  'rate.helps': {
    en: 'New members get more room to sell once someone they traded with says how it went.',
    hi: 'जब सौदे का साथी बताता है कि सौदा कैसा रहा, तब नए सदस्यों को बेचने की ज़्यादा जगह मिलती है।',
  },
  'trades.title': { en: 'Your trades', hi: 'आपके सौदे' },
  'trades.waiting': { en: 'Waiting for confirmation', hi: 'पुष्टि बाक़ी' },
  'trades.none': { en: 'No trades yet. They show here once you agree a deal.', hi: 'अभी कोई सौदा नहीं। सौदा तय होते ही यहाँ दिखेगा।' },
  'trades.done': { en: 'Done', hi: 'पूरा' },

  // J5 Rate and reply
  'rate.title': { en: 'How did it go with {name}?', hi: '{name} के साथ सौदा कैसा रहा?' },
  'rate.5': { en: 'Very well', hi: 'बहुत अच्छा' },
  'rate.4': { en: 'Well', hi: 'अच्छा' },
  'rate.3': { en: 'It was okay', hi: 'ठीक-ठाक' },
  'rate.2': { en: 'There were problems', hi: 'कुछ दिक़्क़तें थीं' },
  'rate.1': { en: 'It went badly', hi: 'बुरा रहा' },
  'rate.note': { en: 'Anything neighbours should know?', hi: 'पड़ोसियों को कुछ बताना चाहें?' },
  'rate.record': {
    en: 'This goes on the colony record. {name} can read it and reply. It cannot be changed later.',
    hi: 'यह कॉलोनी के रिकॉर्ड में जाएगा। {name} इसे पढ़कर जवाब दे [सकते|सकती] हैं। बाद में इसे बदला नहीं जा सकता।',
  },
  'rate.save': { en: 'Put it on the record', hi: 'रिकॉर्ड में डालें' },
  'reply.cta': { en: 'Reply on the record', hi: 'रिकॉर्ड पर जवाब दें' },
  'reply.label': { en: 'Your reply. Everyone who sees this will see your reply.', hi: 'आपका जवाब। यह जिसे दिखेगा, उसे आपका जवाब भी दिखेगा।' },
  'reply.save': { en: 'Post reply', hi: 'जवाब डालें' },
  'said.by': { en: '{name} said', hi: '{name} ने कहा' },
  'said.reply': { en: 'Reply from {name}', hi: '{name} का जवाब' },
  'said.about': { en: 'for {title}', hi: '{title} के लिए' },

  // Standing
  'standing.title': { en: "{name}'s record here", hi: 'यहाँ {name} का रिकॉर्ड' },
  'standing.noScore': { en: 'No stars or scores here. Just what happened.', hi: 'यहाँ कोई स्टार या स्कोर नहीं। बस जो हुआ, वही।' },
  'standing.joinedPhone': { en: 'Joined {date}. Phone number checked.', hi: '{date} को [जुड़े|जुड़ीं]। फ़ोन नंबर जाँचा गया।' },
  'standing.joinedVouch': { en: 'Joined {date}. {voucher} vouched for them.', hi: '{date} को [जुड़े|जुड़ीं]। {voucher} ने पुष्टि की।' },
  'standing.said': { en: 'What people said after trading', hi: 'सौदे के बाद लोगों ने क्या कहा' },
  'standing.nothingSaid': { en: 'No one has said anything yet.', hi: 'अभी किसी ने कुछ नहीं कहा।' },
  'standing.paused': { en: 'Items paused by a steward until {date}.', hi: 'संचालक ने {date} तक इनकी चीज़ें रोकी हैं।' },
  'standing.pausedAfterAppeal': { en: 'Items paused by a steward until {date}, after an appeal.', hi: 'अपील के बाद, संचालक ने {date} तक इनकी चीज़ें रोकी हैं।' },
  'standing.forSale': { en: 'For sale now', hi: 'अभी बिक्री पर' },
  'person.report': { en: 'Report a problem with {name}', hi: '{name} के बारे में शिकायत करें' },

  // J2 Sell
  'sell.title': { en: 'Sell something', hi: 'कुछ बेचें' },
  'sell.count': { en: 'You have {count} of {limit} items up for sale.', hi: 'बिक्री पर आपकी चीज़ें: {limit} में से {count}।' },
  'n.items.one': { en: '{n} item', hi: '{n} चीज़' },
  'n.items.other': { en: '{n} items', hi: '{n} चीज़ें' },
  'sell.what': { en: 'What are you selling?', hi: 'आप क्या बेच [रहे|रही] हैं?' },
  'sell.price': { en: 'Price in ₹', hi: 'दाम (₹ में)' },
  'sell.priceHelp': { en: 'Write 0 to give it away.', hi: 'मुफ़्त देने के लिए 0 लिखें।' },
  'sell.details': { en: 'A few words about it', hi: 'इसके बारे में कुछ शब्द' },
  'sell.post': { en: 'Post item', hi: 'बिक्री पर डालें' },
  'tl.title': { en: 'What happened, in order', hi: 'क्या हुआ, क्रम से' },
  'tl.report': { en: '{name} reported', hi: '{name} ने शिकायत की' },
  'tl.promote': { en: '{name} shared a message as proof', hi: '{name} ने सबूत के तौर पर संदेश दिखाया' },
  'tl.flag': { en: 'The AI added a triage note', hi: 'AI ने जाँच नोट जोड़ा' },
  'tl.decide': { en: '{name} decided: {outcome}', hi: '{name} का फ़ैसला: {outcome}' },
  'tl.respond': { en: '{name} replied on the record', hi: '{name} ने रिकॉर्ड पर जवाब दिया' },
  'tl.appeal': { en: '{name} asked another steward to look again', hi: '{name} ने दूसरे संचालक से फिर देखने को कहा' },
  'sell.kind': { en: 'What kind of thing is it?', hi: 'यह किस तरह की चीज़ है?' },
  'kind.almirah': { en: 'Furniture', hi: 'फ़र्नीचर' },
  'kind.cooker': { en: 'Kitchen', hi: 'रसोई' },
  'kind.phone': { en: 'Phones', hi: 'फ़ोन' },
  'kind.fan': { en: 'Fans and coolers', hi: 'पंखे, कूलर' },
  'kind.books': { en: 'Books', hi: 'किताबें' },
  'kind.cycle': { en: 'Cycles', hi: 'साइकिल' },
  'kind.plant': { en: 'Plants', hi: 'पौधे' },
  'kind.other': { en: 'Something else', hi: 'कुछ और' },
  'sell.posted': { en: 'Your item is up. Neighbours can see it now.', hi: 'आपकी चीज़ बिक्री पर है। पड़ोसी इसे अब देख सकते हैं।' },
  'sell.yours': { en: 'Your items for sale', hi: 'बिक्री पर आपकी चीज़ें' },
  'sell.none': { en: 'Nothing up for sale yet.', hi: 'अभी कुछ बिक्री पर नहीं।' },
  'sell.taken': { en: 'Taken down.', hi: 'हटा दिया गया।' },

  // The denial: why can't I post?
  'why.cantPost': { en: "You can't post a new item right now", hi: 'अभी नई चीज़ नहीं डाली जा सकती' },
  'why.decide': { en: "You can't decide this case", hi: 'इस मामले पर आपका फ़ैसला दर्ज नहीं हो सकता' },
  'why.accept': { en: "You can't agree to buy this", hi: 'इसे ख़रीदना तय नहीं हो सकता' },
  'why.complete': { en: "You can't confirm this handover", hi: 'इस सौंपने की पुष्टि नहीं हो सकती' },
  'why.rate': { en: "You can't say how it went yet", hi: 'अभी नहीं बताया जा सकता कि सौदा कैसा रहा' },
  'why.respond': { en: "You can't reply to this", hi: 'इसका जवाब नहीं दिया जा सकता' },
  'why.report': { en: "This report can't be sent", hi: 'यह शिकायत नहीं भेजी जा सकती' },
  'why.promote': { en: "These messages can't be added", hi: 'ये संदेश नहीं जोड़े जा सकते' },
  'why.vouch': { en: "You can't vouch for this person", hi: 'इनकी पुष्टि नहीं की जा सकती' },
  'why.join': { en: "You can't join yet", hi: 'अभी जुड़ा नहीं जा सकता' },
  'why.policy': { en: "You can't change the rules", hi: 'नियम नहीं बदले जा सकते' },
  'why.inquire': { en: "You can't ask about this", hi: 'इसके बारे में नहीं पूछा जा सकता' },
  'why.withdraw': { en: "You can't take this down", hi: 'इसे हटाया नहीं जा सकता' },
  'why.release': { en: "This deal can't be released", hi: 'यह सौदा छोड़ा नहीं जा सकता' },
  'why.appeal': { en: "You can't appeal this", hi: 'इस पर अपील नहीं हो सकती' },
  'why.flag': { en: "This note can't be added", hi: 'यह राय नहीं जोड़ी जा सकती' },
  'case.r.advance': { en: 'Asked for payment before showing the item', hi: 'चीज़ दिखाने से पहले पैसे माँगे' },
  'case.r.noshow': { en: 'Did not turn up, or did not hand it over', hi: 'मिलने नहीं [आए|आईं], या चीज़ नहीं दी' },
  'case.r.notAsDescribed': { en: 'Item was not as described', hi: 'चीज़ वैसी नहीं थी जैसी बताई गई थी' },
  'case.r.abuse': { en: 'Rude, threatening or unsafe', hi: 'बदतमीज़ी, धमकी या ख़तरा' },
  'case.r.other': { en: 'Something else', hi: 'कुछ और' },
  'riskTitle.high': { en: 'Look at this first', hi: 'इसे पहले देखें' },
  'riskTitle.medium': { en: 'Worth a look', hi: 'देखने लायक' },
  'riskTitle.low': { en: 'Low urgency', hi: 'कम ज़रूरी' },
  'why.what': { en: 'What you can do', hi: 'आप क्या कर सकते हैं' },
  'deny.offer.member': { en: 'You have not joined Gulmohar Colony yet.', hi: 'आप अभी गुलमोहर कॉलोनी के सदस्य नहीं हैं।' },
  'deny.offer.new': {
    en: 'While you are new, you can keep {items} up at a time. You have {count}:',
    hi: 'नए सदस्य एक समय में {items} बिक्री पर रख सकते हैं। अभी बिक्री पर आपकी चीज़ें: {count}',
  },
  'deny.offer.regular': {
    en: 'You can keep {items} up at a time. You have {count}:',
    hi: 'एक समय में {items} बिक्री पर रखी जा सकती हैं। अभी बिक्री पर आपकी चीज़ें: {count}',
  },
  'deny.offer.friction': {
    en: '{reporters} neighbours have reported a problem with you. Until a steward looks at it, you can keep {items} up. You have {count}:',
    hi: '{reporters} पड़ोसियों ने आपके बारे में शिकायत की है। जब तक कोई संचालक इसे नहीं देखता, आप {items} ही बिक्री पर रख सकते हैं। अभी बिक्री पर आपकी चीज़ें: {count}',
  },
  'deny.friction.fair': {
    en: 'This happens automatically. No one has decided anything about you yet.',
    hi: 'यह अपने-आप होता है। आपके बारे में अभी किसी ने कोई फ़ैसला नहीं किया है।',
  },
  'deny.friction.hidden': {
    en: 'Who reported you is not shown to you. A steward sees it.',
    hi: 'शिकायत किसने की, यह आपको नहीं दिखाया जाता। संचालक इसे देखते हैं।',
  },
  'do.takeDown': { en: 'Take one down to post something else.', hi: 'कुछ और डालने के लिए कोई एक चीज़ हटा दें।' },
  'do.ramp': {
    en: 'After a trade, your limit goes up to {limit} when the other person says how it went, or {days} days after you both confirm.',
    hi: 'सौदे के बाद जब सामने वाला बताए कि सौदा कैसा रहा, या दोनों की पुष्टि के {days} दिन बाद, आपकी सीमा {limit} हो जाएगी।',
  },
  'do.join': { en: 'Join first', hi: 'पहले जुड़ें' },
  'do.wait': { en: 'Wait for a steward. You will see their decision here.', hi: 'संचालक के फ़ैसले का इंतज़ार करें। उनका फ़ैसला यहीं दिखेगा।' },

  // One sentence per policy clause, keyed `deny.<label>` (kernel R1). Each says what failed, in the person's terms.
  'deny.unknown': { en: 'The colony rules do not allow this.', hi: 'कॉलोनी के नियम इसकी अनुमति नहीं देते।' },
  'deny.signature': { en: 'This did not come from your phone, so it was not accepted.', hi: 'यह आपके फ़ोन से नहीं आया, इसलिए स्वीकार नहीं हुआ।' },
  'deny.ruleError': { en: 'Something went wrong while checking the rules. Nothing was changed.', hi: 'नियम जाँचते समय कुछ गड़बड़ हुई। कुछ नहीं बदला गया।' },
  'deny.badPolicy': { en: 'This rule change is not valid. Nothing was changed.', hi: 'नियम का यह बदलाव सही नहीं है। कुछ नहीं बदला गया।' },
  'deny.offer.frictionAtLeast': {
    en: 'At least {reporters} neighbours have reported a problem with you. Until a steward looks at it, you can keep {items} up. You have {count}:',
    hi: 'कम से कम {reporters} पड़ोसियों ने आपके बारे में शिकायत की है। जब तक कोई संचालक इसे नहीं देखता, आप {items} ही बिक्री पर रख सकते हैं। अभी बिक्री पर आपकी चीज़ें: {count}',
  },
  'deny.join.not-member': { en: 'You are already a member.', hi: 'आप पहले से सदस्य हैं।' },
  'deny.join.attested-or-vouched': {
    en: 'To join, check your phone number, or have a member vouch for you.',
    hi: 'जुड़ने के लिए अपना फ़ोन नंबर जाँचें, या किसी सदस्य से अपनी पुष्टि करवाएँ।',
  },
  'deny.vouch.member': { en: 'Only members of Gulmohar Colony can vouch for someone.', hi: 'किसी की पुष्टि सिर्फ़ गुलमोहर कॉलोनी के सदस्य कर सकते हैं।' },
  'deny.vouch.not-self': { en: 'You cannot vouch for yourself.', hi: 'आप अपनी पुष्टि ख़ुद नहीं कर सकते।' },
  'deny.vouch.first-for-subject': { en: 'You have already vouched for this person.', hi: 'आप इनकी पुष्टि पहले ही कर चुके हैं।' },
  'deny.vouch.scope-bound': { en: 'This was meant for a different colony, so it has no effect here.', hi: 'यह किसी दूसरी कॉलोनी के लिए था, इसलिए यहाँ इसका कोई असर नहीं।' },
  'deny.vouch.attested': {
    en: 'Only members who checked their phone number can vouch for others.',
    hi: 'दूसरों की पुष्टि सिर्फ़ वही सदस्य कर सकते हैं जिन्होंने अपना फ़ोन नंबर जँचवाया है।',
  },
  'deny.vouch.cap': {
    en: 'You have vouched for {cap} people in the last {days} days. That is the limit for now.',
    hi: 'पिछले {days} दिनों में आप {cap} लोगों की पुष्टि कर चुके हैं। अभी के लिए यही सीमा है।',
  },
  'deny.withdraw.own': { en: 'Only the seller can take an item down.', hi: 'चीज़ सिर्फ़ बेचने वाले ही हटा सकते हैं।' },
  'deny.inquire.member': { en: 'Only members of Gulmohar Colony can ask about items.', hi: 'चीज़ों के बारे में सिर्फ़ गुलमोहर कॉलोनी के सदस्य पूछ सकते हैं।' },
  'deny.inquire.not-own': { en: 'This is your own item.', hi: 'यह आपकी अपनी चीज़ है।' },
  'deny.accept.member': { en: 'Only members of Gulmohar Colony can buy here.', hi: 'यहाँ सिर्फ़ गुलमोहर कॉलोनी के सदस्य ख़रीद सकते हैं।' },
  'deny.accept.not-own': { en: 'This is your own item.', hi: 'यह आपकी अपनी चीज़ है।' },
  'deny.accept.not-withdrawn': { en: 'The seller took this down.', hi: 'बेचने वाले ने इसे हटा दिया है।' },
  'deny.accept.not-taken': { en: 'Someone has already agreed to buy this.', hi: 'इसे ख़रीदने की बात किसी से पहले ही पक्की हो चुकी है।' },
  'deny.release.party': { en: 'Only the buyer and the seller can release a deal.', hi: 'सौदा सिर्फ़ ख़रीदने और बेचने वाले ही छोड़ सकते हैं।' },
  'deny.release.open': {
    en: 'You have both confirmed the handover, so this deal is done and cannot be released.',
    hi: 'आप दोनों सौंपने की पुष्टि कर चुके हैं, इसलिए सौदा पूरा है और अब छोड़ा नहीं जा सकता।',
  },
  'deny.release.once': { en: 'This deal was already released.', hi: 'यह सौदा पहले ही छोड़ा जा चुका है।' },
  'deny.complete.party': { en: 'Only the buyer and the seller can confirm the handover.', hi: 'सौंपने की पुष्टि सिर्फ़ ख़रीदने और बेचने वाले कर सकते हैं।' },
  'deny.complete.once': { en: 'You have already confirmed.', hi: 'आप पहले ही पुष्टि कर [चुके|चुकी] हैं।' },
  'deny.complete.not-released': { en: 'This deal was released, so it cannot be confirmed.', hi: 'यह सौदा छोड़ दिया गया था, इसलिए इसकी पुष्टि नहीं हो सकती।' },
  'deny.rate.accept': {
    en: 'You can only say how a trade went if you were part of it.',
    hi: 'सौदा कैसा रहा, यह सिर्फ़ वही बता सकते हैं जो उस सौदे में शामिल थे।',
  },
  'deny.rate.both-confirmed': {
    en: 'You can say how it went once you both confirm the handover.',
    hi: 'दोनों के सौंपने की पुष्टि करने के बाद ही आप बता सकते हैं कि सौदा कैसा रहा।',
  },
  'deny.rate.party': {
    en: 'You can only say how a trade went if you were part of it.',
    hi: 'सौदा कैसा रहा, यह सिर्फ़ वही बता सकते हैं जो उस सौदे में शामिल थे।',
  },
  'deny.rate.about-counterparty': { en: 'You can only say how it went with the other person in this trade.', hi: 'आप सिर्फ़ इस सौदे के दूसरे व्यक्ति के बारे में बता सकते हैं।' },
  'deny.rate.not-self': { en: 'You cannot say how it went with yourself.', hi: 'आप अपने बारे में नहीं बता सकते।' },
  'deny.rate.once': { en: 'You have already said how this trade went.', hi: 'आप पहले ही बता [चुके|चुकी] हैं कि यह सौदा कैसा रहा।' },
  'deny.rate.min': { en: 'Pick one of the five answers.', hi: 'पाँच में से कोई एक जवाब चुनें।' },
  'deny.rate.max': { en: 'Pick one of the five answers.', hi: 'पाँच में से कोई एक जवाब चुनें।' },
  'deny.rate.not-vouch-linked': {
    en: 'You cannot say how it went with someone you vouched for, or who vouched for you.',
    hi: 'जिनकी आपने पुष्टि की, या जिन्होंने आपकी पुष्टि की, उनके साथ सौदा कैसा रहा, यह आप नहीं बता सकते।',
  },
  'deny.respond.subject': { en: 'Only the person it is about can reply.', hi: 'जवाब सिर्फ़ वही दे सकते हैं जिनके बारे में यह लिखा गया है।' },
  'deny.respond.once': { en: 'You have already replied to this.', hi: 'आप इसका जवाब पहले ही दे [चुके|चुकी] हैं।' },
  'deny.appeal.subject': { en: 'Only the person a decision is about can appeal it.', hi: 'फ़ैसले पर अपील सिर्फ़ वही कर सकते हैं जिनके बारे में फ़ैसला है।' },
  'deny.appeal.once': { en: 'This decision has already been appealed.', hi: 'इस फ़ैसले पर पहले ही अपील हो चुकी है।' },
  'deny.report.member': { en: 'Only members of Gulmohar Colony can report.', hi: 'शिकायत सिर्फ़ गुलमोहर कॉलोनी के सदस्य कर सकते हैं।' },
  'deny.report.subject-member': { en: 'This person is not a member here.', hi: 'ये व्यक्ति यहाँ के सदस्य नहीं हैं।' },
  'deny.report.not-self': { en: 'You cannot report yourself.', hi: 'आप अपनी शिकायत ख़ुद नहीं कर सकते।' },
  'deny.report.attested': {
    en: 'You joined on a neighbour’s word, so you cannot report yet. Ask the neighbour who vouched for you, or check your phone number first.',
    hi: 'आप किसी पड़ोसी के भरोसे से जुड़े हैं, इसलिए अभी शिकायत नहीं कर सकते। जिन्होंने आपकी पुष्टि की, उनसे कहें, या पहले अपना फ़ोन नंबर जँचवाएँ।',
  },
  'deny.report.attestedBy': {
    en: 'You joined on {voucher}’s word, so you cannot report yet. Ask {voucher} to report it, or check your phone number first.',
    hi: 'आप {voucher} के भरोसे से जुड़े हैं, इसलिए अभी शिकायत नहीं कर सकते। {voucher} से शिकायत करने को कहें, या पहले अपना फ़ोन नंबर जँचवाएँ।',
  },
  'deny.report.cap': {
    en: 'You have sent {cap} reports today. You can report again tomorrow.',
    hi: 'आज आप {cap} शिकायतें भेज [चुके|चुकी] हैं। कल फिर शिकायत कर सकते हैं।',
  },
  'deny.promote.case-party': {
    en: 'Only the person who reported, or the person reported, can add proof to a report.',
    hi: 'शिकायत में सबूत सिर्फ़ शिकायत करने वाले या जिनकी शिकायत हुई है, वही जोड़ सकते हैं।',
  },
  'deny.promote.between-parties': {
    en: 'Only messages between you and the person you reported can be added.',
    hi: 'सिर्फ़ आपके और जिनकी शिकायत की गई है, उनके बीच के संदेश जोड़े जा सकते हैं।',
  },
  'deny.flag.triage': { en: 'Only the triage agent named in the rules can add triage notes.', hi: 'AI की राय सिर्फ़ नियमों में दर्ज AI ही जोड़ सकता है।' },
  'deny.decide.steward': {
    en: 'Only stewards named in the colony rules can decide. Stewards here: {names}.',
    hi: 'फ़ैसला सिर्फ़ वही संचालक कर सकते हैं जिनके नाम कॉलोनी के नियमों में हैं। यहाँ के संचालक: {names}।',
  },
  'deny.decide.not-self': { en: 'A steward cannot decide a case about themselves.', hi: 'कोई संचालक अपने ही बारे में मामले का फ़ैसला नहीं कर सकता।' },
  'deny.decide.each-report': {
    en: 'You reported this person yourself, or these reports are already decided. Another steward must decide.',
    hi: 'आपने ख़ुद इनकी शिकायत की है, या इन शिकायतों पर फ़ैसला हो चुका है। फ़ैसला कोई दूसरा संचालक करेगा।',
  },
  'deny.decide.other-steward': {
    en: 'You made the original decision, so another steward must decide this appeal.',
    hi: 'मूल फ़ैसला आपने किया था, इसलिए इस अपील का फ़ैसला कोई दूसरा संचालक करेगा।',
  },
  'deny.decide.once': { en: 'This appeal has already been decided.', hi: 'इस अपील पर फ़ैसला हो चुका है।' },
  'deny.policy.by-community': { en: 'Only the colony itself can change the rules.', hi: 'नियम सिर्फ़ कॉलोनी ख़ुद बदल सकती है।' },
  'deny.phone.issuer': { en: 'Only the phone check service named in the rules can confirm numbers.', hi: 'नंबर की पुष्टि सिर्फ़ नियमों में दर्ज फ़ोन जाँच सेवा कर सकती है।' },

  // J10 Consequence
  'paused.title': { en: 'Your items are paused until {date}', hi: '{date} तक आपकी चीज़ें रुकी हुई हैं' },
  'paused.who': {
    en: '{steward}, a steward, decided this after neighbours reported a problem.',
    hi: 'पड़ोसियों की शिकायत के बाद संचालक {steward} ने यह फ़ैसला किया।',
  },
  'paused.reason': { en: 'Their reason', hi: 'उनका कारण' },
  'paused.whoAppeal': {
    en: 'After your appeal, {steward}, a different steward, looked again and changed the decision.',
    hi: 'आपकी अपील के बाद एक दूसरे संचालक, {steward}, ने मामला फिर से देखा और फ़ैसला बदला।',
  },
  'paused.yourReply': { en: 'Your reply on the record', hi: 'रिकॉर्ड पर आपका जवाब' },
  'paused.replyCta': { en: 'Reply on the record', hi: 'रिकॉर्ड पर जवाब दें' },
  'paused.appealCta': { en: 'Ask another steward to look again', hi: 'किसी दूसरे संचालक से दोबारा देखने को कहें' },

  // J11 Reply and appeal
  'replyDecision.help': {
    en: 'Your reply is shown next to the decision, to everyone who can see it. You can reply once. It does not change the decision.',
    hi: 'आपका जवाब फ़ैसले के साथ दिखेगा, उन सबको जिन्हें फ़ैसला दिखता है। आप एक बार जवाब दे सकते हैं। इससे फ़ैसला नहीं बदलता।',
  },
  'appeal.title': { en: 'Ask another steward to look again', hi: 'किसी दूसरे संचालक से दोबारा देखने को कहें' },
  'appeal.body': {
    en: '{steward} made this decision. A different steward will read the reports, the messages shared as proof and what you write here, then decide. You can appeal once.',
    hi: 'यह फ़ैसला {steward} ने किया था। कोई दूसरा संचालक शिकायतें, सबूत के संदेश और आपका लिखा पढ़कर फ़ैसला करेगा। आप एक बार अपील कर सकते हैं।',
  },
  'appeal.label': { en: 'What should the other steward know?', hi: 'दूसरे संचालक को क्या जानना चाहिए?' },
  'appeal.who': { en: 'Only stewards see your appeal.', hi: 'आपकी अपील सिर्फ़ संचालक देखेंगे।' },
  'appeal.send': { en: 'Send appeal', hi: 'अपील भेजें' },
  'appeal.sent': { en: 'Appeal sent. A different steward will decide.', hi: 'अपील भेज दी गई। फ़ैसला कोई दूसरा संचालक करेगा।' },
  'appeal.waiting': { en: 'You appealed on {date}. A different steward will decide.', hi: 'आपने {date} को अपील की। फ़ैसला कोई दूसरा संचालक करेगा।' },
  'appeals.row': { en: 'Appeal from {name}', hi: '{name} की अपील' },
  'appeals.meta': { en: '{steward} decided on {date}', hi: '{steward} ने {date} को फ़ैसला किया' },
  'appealCase.title': { en: 'Appeal from {name}', hi: '{name} की अपील' },
  'appealCase.decision': { en: 'The decision being appealed', hi: 'जिस फ़ैसले पर अपील है' },
  'appealCase.by': { en: '{steward} · {date} · {outcome}', hi: '{steward} · {date} · {outcome}' },
  'appealCase.appeal': { en: 'What {name} wrote', hi: '{name} ने क्या लिखा' },
  'appealCase.reply': { en: 'Reply on the record', hi: 'रिकॉर्ड पर जवाब' },
  'appealCase.original': { en: 'The original reports', hi: 'मूल शिकायतें' },
  'appealCase.decide': { en: 'Decide the appeal', hi: 'अपील पर फ़ैसला करें' },
  'appealDecide.keep': { en: 'Keep the pause until {date}', hi: '{date} तक की रोक बनाए रखें' },
  'appealDecide.shorten': { en: 'Shorten the pause to end on {date}', hi: 'रोक घटाकर {date} तक करें' },
  'appealDecide.lift': { en: 'Lift the pause now', hi: 'रोक अभी हटा दें' },
  'appealDecide.note': {
    en: 'Your decision replaces the original one. It is final: it cannot be appealed again.',
    hi: 'आपका फ़ैसला मूल फ़ैसले की जगह लेगा। यह आख़िरी है: इस पर फिर अपील नहीं हो सकती।',
  },
  'appealDecide.done': { en: 'Appeal decided. {name} can see your decision.', hi: 'अपील पर फ़ैसला हो गया। {name} आपका फ़ैसला देख सकते हैं।' },
  'outcome.afterAppeal': { en: 'after an appeal, {outcome}', hi: 'अपील के बाद, {outcome}' },

  // J12 Release
  'trade.releaseCta': { en: 'This deal fell through', hi: 'यह सौदा नहीं हो पाया' },
  'trade.releaseHelp': {
    en: 'Either of you can release the deal until you both confirm. The item goes back on sale.',
    hi: 'दोनों की पुष्टि से पहले आप में से कोई भी सौदा छोड़ सकता है। चीज़ फिर से बिक्री पर आ जाती है।',
  },
  'release.title': { en: 'Release this deal?', hi: 'यह सौदा छोड़ दें?' },
  'release.body': {
    en: '{title} goes back on sale. {name} will see that you released it and can no longer confirm. Do this only if the handover is not going to happen.',
    hi: '{title} फिर से बिक्री पर आ जाएगी। {name} देख सकेंगे कि आपने सौदा छोड़ा, और अब पुष्टि नहीं कर पाएँगे। ऐसा तभी करें जब सौंपना अब नहीं होगा।',
  },
  'release.yes': { en: 'Release the deal', hi: 'सौदा छोड़ दें' },
  'release.done': { en: 'Released. {title} is back on sale.', hi: 'सौदा छोड़ दिया गया। {title} फिर से बिक्री पर है।' },
  'trade.releasedByMe': { en: 'You released this deal on {date}. The item is back on sale.', hi: 'आपने {date} को यह सौदा छोड़ दिया। चीज़ फिर से बिक्री पर है।' },
  'trade.releasedBy': { en: '{name} released this deal on {date}. The item is back on sale.', hi: '{name} ने {date} को यह सौदा छोड़ दिया। चीज़ फिर से बिक्री पर है।' },
  'trades.released': { en: 'Released', hi: 'छोड़ा गया' },
  'trade.agreedAgo': { en: 'Agreed {ago}. Neither of you has confirmed yet.', hi: 'सौदा {ago} तय हुआ। अभी किसी ने पुष्टि नहीं की।' },
  'paused.still': {
    en: 'You can still buy, chat and confirm trades. From {date} you can post again.',
    hi: 'आप अब भी ख़रीद सकते हैं, बातचीत कर सकते हैं और सौदों की पुष्टि कर सकते हैं। {date} से आप फिर चीज़ें डाल सकेंगे।',
  },
  'paused.hidden': { en: 'Your items are hidden from neighbours until then.', hi: 'तब तक आपकी चीज़ें पड़ोसियों को नहीं दिखेंगी।' },
  'paused.ended': { en: 'Your pause ended on {date}.', hi: 'आपकी रोक {date} को ख़त्म हो गई।' },

  // J6 Report
  'report.title': { en: 'Report a problem with {name}', hi: '{name} के बारे में शिकायत करें' },
  'report.what': { en: 'What happened?', hi: 'क्या हुआ?' },
  'report.r.advance': { en: 'Asked me to pay before I saw the item', hi: 'चीज़ दिखाने से पहले पैसे माँगे' },
  'report.r.noshow': { en: "Didn't turn up, or didn't hand it over", hi: 'मिलने नहीं [आए|आईं], या चीज़ नहीं दी' },
  'report.r.notAsDescribed': { en: 'The item was not as described', hi: 'चीज़ वैसी नहीं थी जैसी बताई गई थी' },
  'report.r.abuse': { en: 'Rude, threatening or unsafe', hi: 'बदतमीज़ी, धमकी या ख़तरा' },
  'report.r.other': { en: 'Something else', hi: 'कुछ और' },
  'report.details': { en: 'Tell the steward what happened', hi: 'संचालक को बताएँ क्या हुआ' },
  'report.attach': { en: 'Add messages from your chat as proof', hi: 'सबूत के तौर पर अपनी बातचीत के संदेश जोड़ें' },
  'report.attachHelp': {
    en: "Only stewards see these. {name} won't see your name or these messages.",
    hi: 'ये सिर्फ़ संचालक देखेंगे। {name} को आपका नाम या ये संदेश नहीं दिखेंगे।',
  },
  'report.ai': {
    en: 'An AI may sort reports by urgency. It reads what you write here, not your messages. Only a person decides.',
    hi: 'एक AI शिकायतों को ज़रूरत के हिसाब से क्रम में लगा सकता है। वह आपका लिखा पढ़ता है, आपके संदेश नहीं। फ़ैसला सिर्फ़ इंसान करता है।',
  },
  'report.send': { en: 'Send report', hi: 'शिकायत भेजें' },
  'report.danger': { en: 'If you are in danger, call 112.', hi: 'अगर आप ख़तरे में हैं, तो 112 पर फ़ोन करें।' },
  'report.sent': {
    en: "Sent. A steward will look at it. {name} won't see who reported.",
    hi: 'शिकायत भेज दी गई। कोई संचालक इसे देखेगा। {name} को पता नहीं चलेगा कि शिकायत किसने की।',
  },
  'report.already': {
    en: 'You reported {name} on {date}. A steward has not decided yet.',
    hi: 'आपने {date} को {name} की शिकायत की थी। संचालक ने अभी फ़ैसला नहीं किया है।',
  },
  'report.addMore': { en: 'Add messages to that report', hi: 'उस शिकायत में संदेश जोड़ें' },
  'report.added': { en: 'Added to your report.', hi: 'आपकी शिकायत में जोड़ दिया गया।' },
  'reports.title': { en: 'Your reports', hi: 'आपकी शिकायतें' },
  'reports.open': { en: 'About {name}. Waiting for a steward.', hi: '{name} के बारे में। संचालक के फ़ैसले का इंतज़ार।' },
  'reports.closed': { en: 'About {name}. {steward} decided: {outcome}', hi: '{name} के बारे में। {steward} का फ़ैसला: {outcome}' },

  // J8 Case
  'cases.title': { en: 'Open cases', hi: 'खुले मामले' },
  'cases.empty': { en: 'No open cases.', hi: 'कोई खुला मामला नहीं।' },
  'cases.reports.one': { en: '1 report', hi: '1 शिकायत' },
  'cases.reports.other': { en: '{n} reports', hi: '{n} शिकायतें' },
  'cases.ai': { en: 'Triage note: {level}', hi: 'AI की राय: {level}' },
  'cases.noAi': { en: 'No triage note yet', hi: 'अभी AI की राय नहीं' },
  'case.title': { en: 'Reports about {name}', hi: '{name} के बारे में शिकायतें' },
  'case.reported': { en: 'What neighbours reported', hi: 'पड़ोसियों ने क्या बताया' },
  'case.proof': { en: 'Messages shared as proof', hi: 'सबूत के तौर पर दिए गए संदेश' },
  'case.noProof': { en: 'No messages were shared.', hi: 'कोई संदेश नहीं दिया गया।' },
  'case.sig': { en: 'Checked: sent from {from}’s phone to {to}, {date}.', hi: 'जाँचा गया: {from} के फ़ोन से {to} को भेजा गया, {date}।' },
  'case.sigBad': { en: 'This message does not check out. Treat it as unproven.', hi: 'यह संदेश जाँच में सही नहीं निकला। इसे अप्रमाणित मानें।' },
  'case.ai': { en: 'Triage note from the AI. Advice only.', hi: 'AI की राय। सिर्फ़ सलाह।' },
  'case.noAi': { en: 'No triage note yet.', hi: 'अभी AI की राय नहीं।' },
  'case.record': { en: "{name}'s record", hi: '{name} का रिकॉर्ड' },
  'case.now': { en: 'Right now', hi: 'अभी की स्थिति' },
  'case.nowFriction': {
    en: '{name} can keep only {items} up. This happened automatically because {reporters} neighbours reported.',
    hi: '{name} सिर्फ़ {items} बिक्री पर रख [सकते|सकती] हैं। यह अपने-आप हुआ, क्योंकि {reporters} पड़ोसियों ने शिकायत की।',
  },
  'case.nowNone': { en: 'Nothing has changed for {name} yet. One report alone does not slow anyone down.', hi: '{name} के लिए अभी कुछ नहीं बदला। सिर्फ़ एक शिकायत से किसी पर रोक नहीं लगती।' },
  'case.decide': { en: 'Decide', hi: 'फ़ैसला करें' },

  // J9 Decide
  'decide.title': { en: 'Decide about {name}', hi: '{name} के बारे में फ़ैसला' },
  'decide.what': { en: 'What should happen?', hi: 'क्या होना चाहिए?' },
  'decide.none': { en: 'No action. Close the reports.', hi: 'कोई कार्रवाई नहीं। शिकायतें बंद करें।' },
  'decide.pause': { en: 'Pause their items for {days} days', hi: '{days} दिन के लिए इनकी चीज़ें रोकें' },
  'decide.reason': { en: 'Your reason. {name} will read it.', hi: 'आपका कारण। {name} इसे [पढ़ेंगे|पढ़ेंगी]।' },
  'decide.public': {
    en: 'If you pause, neighbours will see that the items are paused, and until when. No one will see who reported.',
    hi: 'रोक लगाने पर पड़ोसी देखेंगे कि चीज़ें रोकी गई हैं, और कब तक। शिकायत किसने की, यह किसी को नहीं दिखेगा।',
  },
  'decide.final': {
    en: 'A decision cannot be undone. A pause ends on its own date.',
    hi: 'फ़ैसला वापस नहीं लिया जा सकता। रोक अपनी तारीख़ पर ख़ुद ख़त्म हो जाती है।',
  },
  'decide.confirm': { en: 'Record decision', hi: 'फ़ैसला दर्ज करें' },
  'decide.sure': { en: 'Record this decision about {name}?', hi: '{name} के बारे में यह फ़ैसला दर्ज करें?' },
  'decide.done': { en: 'Decision recorded. {name} and the people who reported can see it.', hi: 'फ़ैसला दर्ज हो गया। {name} और शिकायत करने वाले इसे देख सकते हैं।' },
  'outcome.none': { en: 'no action', hi: 'कोई कार्रवाई नहीं' },
  'outcome.pause': { en: 'items paused until {date}', hi: '{date} तक चीज़ें रोकी गईं' },

  // Triage seat
  'triage.title': { en: 'Reports waiting for a triage note', hi: 'AI की राय के इंतज़ार में शिकायतें' },
  'triage.body': {
    en: 'This agent reads report text and public records, never private messages. Its notes are advice for stewards.',
    hi: 'यह AI सिर्फ़ शिकायत का लिखा और सार्वजनिक रिकॉर्ड पढ़ता है, निजी संदेश कभी नहीं। इसकी राय संचालकों के लिए सलाह है।',
  },
  'triage.run': { en: 'Add triage notes', hi: 'AI की राय जोड़ें' },
  'triage.none': { en: 'Every report has a triage note.', hi: 'हर शिकायत पर AI की राय है।' },
  'triage.try': { en: 'Try to decide a case', hi: 'किसी मामले पर फ़ैसला करने की कोशिश करें' },
  'triage.tryHelp': { en: 'Shows what the rules do when software tries to sanction someone.', hi: 'दिखाता है कि जब सॉफ़्टवेयर किसी पर रोक लगाने की कोशिश करता है, तो नियम क्या करते हैं।' },
  'risk.high': { en: 'look at this first', hi: 'इसे पहले देखें' },
  'risk.medium': { en: 'worth a look', hi: 'देखने लायक' },
  'risk.low': { en: 'low urgency', hi: 'कम ज़रूरी' },

  // Rules
  'rules.title': { en: 'How Gulmohar Colony works', hi: 'गुलमोहर कॉलोनी कैसे चलती है' },
  'rules.join': { en: 'To join, check your phone number or have a member vouch for you.', hi: 'जुड़ने के लिए अपना फ़ोन नंबर जाँचें या किसी सदस्य से पुष्टि करवाएँ।' },
  'rules.new': { en: 'New members can keep {items} up for sale at a time.', hi: 'नए सदस्य एक समय में {items} बिक्री पर रख सकते हैं।' },
  'rules.after': {
    en: 'After a trade: {n}, once the other person says how it went, or {days} days after both confirm.',
    hi: 'सौदे के बाद: {n}, जब सामने वाला बताए कि सौदा कैसा रहा, या दोनों की पुष्टि के {days} दिन बाद।',
  },
  'rules.appeal': {
    en: 'The person a decision is about can reply on the record and appeal once. A different steward decides the appeal.',
    hi: 'जिनके बारे में फ़ैसला है, वे रिकॉर्ड पर जवाब दे सकते हैं और एक बार अपील कर सकते हैं। अपील पर फ़ैसला कोई दूसरा संचालक करता है।',
  },
  'rules.release': {
    en: 'Until both people confirm a handover, either of them can release the deal and the item goes back on sale.',
    hi: 'जब तक दोनों सौंपने की पुष्टि न करें, कोई भी सौदा छोड़ सकता है और चीज़ फिर से बिक्री पर आ जाती है।',
  },
  'rules.vouchOnly': {
    en: 'Members who joined on a neighbour’s word can buy and sell, but cannot vouch or report until they check their phone number.',
    hi: 'किसी पड़ोसी के भरोसे से जुड़े सदस्य ख़रीद-बेच सकते हैं, पर फ़ोन नंबर जँचवाने तक पुष्टि या शिकायत नहीं कर सकते।',
  },
  'rules.caps': {
    en: 'Each member can vouch for up to {v} people in {vd} days, and send up to {r} reports a day.',
    hi: 'हर सदस्य {vd} दिनों में {v} लोगों तक की पुष्टि कर सकता है, और दिन में {r} शिकायतें तक भेज सकता है।',
  },
  'rules.linked': {
    en: 'You cannot say how a trade went with someone you vouched for, or who vouched for you.',
    hi: 'जिनकी आपने पुष्टि की या जिन्होंने आपकी पुष्टि की, उनके साथ सौदा कैसा रहा, यह नहीं बताया जा सकता।',
  },
  'rules.friction': {
    en: 'If at least {r} neighbours report someone, that person can keep only {items} up until a steward looks at it.',
    hi: 'अगर कम से कम {r} पड़ोसी किसी की शिकायत करें, तो संचालक के देखने तक वह व्यक्ति सिर्फ़ {items} बिक्री पर रख सकता है।',
  },
  'rules.stewards': { en: 'Only stewards decide what happens after a report. Stewards: {names}.', hi: 'शिकायत के बाद क्या होगा, यह सिर्फ़ संचालक तय करते हैं। संचालक: {names}।' },
  'rules.ai': { en: 'An AI helps sort reports. It cannot decide.', hi: 'शिकायतों को क्रम में लगाने में एक AI मदद करता है। वह फ़ैसला नहीं कर सकता।' },
  'rules.rating': { en: 'You can say how a trade went only after both people confirm it.', hi: 'सौदा कैसा रहा, यह दोनों की पुष्टि के बाद ही बताया जा सकता है।' },
  'rules.forget': { en: 'Phone numbers are checked and then forgotten.', hi: 'फ़ोन नंबर जाँचे जाते हैं, फिर भुला दिए जाते हैं।' },
  'rules.change': { en: 'Only the colony can change these rules, and every change goes on the record.', hi: 'ये नियम सिर्फ़ कॉलोनी बदल सकती है, और हर बदलाव रिकॉर्ड में जाता है।' },
  'rules.edit': { en: 'Change the limits', hi: 'सीमाएँ बदलें' },
  'rules.publish': { en: 'Publish rule change', hi: 'नियम का बदलाव जारी करें' },
  'rules.published': { en: 'Published. Everyone now sees the new rule.', hi: 'जारी हो गया। अब सबको नया नियम दिखता है।' },
  'rules.f.new': { en: 'Items a new member can keep up', hi: 'नया सदस्य कितनी चीज़ें रख सकता है' },
  'rules.f.after': { en: 'Items after a first trade', hi: 'पहले सौदे के बाद कितनी चीज़ें' },
  'rules.f.reporters': { en: 'Neighbours whose reports slow someone down', hi: 'कितने पड़ोसियों की शिकायत पर रोक लगे' },
  'rules.f.friction': { en: 'Items allowed while slowed down', hi: 'रोक के दौरान कितनी चीज़ें' },

  // Me
  'me.language': { en: 'Language', hi: 'भाषा' },
  'me.rules': { en: 'How this colony works', hi: 'यह कॉलोनी कैसे चलती है' },
  'me.record': { en: 'See my record as neighbours see it', hi: 'मेरा रिकॉर्ड, जैसा पड़ोसी देखते हैं' },
} satisfies Record<string, Entry>;

export type Key = keyof typeof S;

let current: Lang = 'en';
export const lang = (): Lang => current;
export function setLang(l: Lang): void {
  current = l;
  document.documentElement.lang = l === 'hi' ? 'hi' : 'en-IN';
}

export type Vars = Record<string, string | number> & { g?: 'm' | 'f' };

export function t(key: Key, vars: Vars = {}, l: Lang = current): string {
  let s = S[key][l];
  s = s.replace(/\[([^|\]]+)\|([^\]]+)\]/g, (_, m: string, f: string) => (vars.g === 'f' ? f : m));
  return s.replace(/\{(\w+)\}/g, (_, k: string) => (k in vars ? String(vars[k]) : `{${k}}`));
}

export function both(key: Key, vars: Vars = {}): Entry {
  return { en: t(key, vars, 'en'), hi: t(key, vars, 'hi') };
}

export const items = (n: number, l: Lang = current): string => t(n === 1 ? 'n.items.one' : 'n.items.other', { n }, l);

export function tn(base: 'trades' | 'cases.reports', n: number, vars: Vars = {}): string {
  const k = (n === 0 && base === 'trades' ? `${base}.zero` : n === 1 ? `${base}.one` : `${base}.other`) as Key;
  return t(k, { ...vars, n });
}

export const STRINGS = S;
